import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import MobileDevPageVideoStageGak from './gak/MobileDevPageVideoStage';
import MobileDevPageVideoStageNitro from './nitro/MobileDevPageVideoStage';
const MobileDevPageVideoStage = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(MobileDevPageVideoStageGak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageVideoStageNitro, {
        safety: safety
    });
};
MobileDevPageVideoStage.displayName = 'MobileDevPageVideoStage';
export default MobileDevPageVideoStage;
